// extracted by mini-css-extract-plugin
export default {"pageWrapper":"ProductListPage_pageWrapper__e0K7d","listWrapper":"ProductListPage_listWrapper__Wv060","title":"ProductListPage_title__TitlN"};